import React from 'react';
import Icon, { IconProps } from './Icon';

// refresh-ccw-01 *
const RedoOutlinedSvg: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M2 10C2 10 4.00498 7.26822 5.63384 5.63824C7.26269 4.00827 9.5136 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.89691 21 4.43511 18.2543 3.35177 14.5M2 10V4M2 10H8"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
const RedoOutlined: React.FC<Omit<IconProps, 'component'>> = (props) => (
    <Icon component={RedoOutlinedSvg} className="s9sicon-redo" {...props} />
);
export default RedoOutlined;
